import {
  IWidgetSettings,
  IWidgetSettingsFormData
} from '@/models/Widget/settings';

export function transformWidgetPayload(
  formData: IWidgetSettingsFormData
): IWidgetSettings {
  const { enabled, placement, widgetStyle, welcome } = formData;
  const { positioning, desktop, mobile } = placement;
  const { color, icon, launcher, text } = widgetStyle;
  const { title, description, enable, visibility } = welcome;

  const payload: IWidgetSettings = {
    enabled,
    position: positioning,
    desktopSideSpacing: desktop.horizontally,
    desktopBottomSpacing: desktop.vertically,
    mobileSideSpacing: mobile.horizontally,
    mobileBottomSpacing: mobile.vertically,
    color,
    desktopWelcome: visibility === 'desktop' || visibility === 'both',
    mobileWelcome: visibility === 'mobile' || visibility === 'both',
    widgetStyleIcon: icon,
    welcomeTitle: title,
    welcomeDescription: description,
    widgetStyleText: launcher === 'only' ? '' : text,
    welcomeEnable: enable
  };

  return payload;
}
